"use client";
import { useState } from "react";

export type RateProps = {
  value: number;
  size?: string;
  clickable?: boolean;
  onChange?: (value: number) => void;
};
export const RateCustom: React.FC<RateProps> = ({
  value,
  size = "18px",
  clickable = false,
  onChange,
  ...props
}) => {
  const fullStars = Math.floor(value); // 整数部分对应的实心星数
  const halfStar = value % 1 >= 0.5 ? 1 : 0; // 小数部分大于等于 0.5 则显示半颗星
  const [fullStarsNum, setFullStarsNum] = useState(fullStars);
  const emptyStars = 5 - fullStarsNum - halfStar; // 空心星数
  const stars = [];

  // 生成实心星
  for (let i = 0; i < fullStarsNum; i++) {
    stars.push(
      <iconpark-icon
        icon-id={`starzhuangtaimanxing${i}`}
        key={`full-${i}`}
        size={size}
        name="starzhuangtaimanxing"
        customValue={i + 1}
        onClick={(e) => {
          if (clickable) {
            const target = e.target as Element; // 类型断言
            setFullStarsNum(Number(target.getAttribute("customValue")));
            onChange?.(Number(target.getAttribute("customValue")));
          }
        }}
      />,
    );
  }

  // 生成半颗星
  if (halfStar) {
    stars.push(
      <iconpark-icon key="half" icon-id="half-star" size="18px" name="starzhuangtaibanxing" />,
    );
  }

  // 生成空心星
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <iconpark-icon
        key={`empty-${i}`}
        size="18px"
        icon-id={`starzhuangtaikongbai${i}`}
        name="starzhuangtaikongbai"
        customValue={fullStarsNum + i + 1}
        onClick={(e) => {
          if (clickable) {
            const target = e.target as Element;
            setFullStarsNum(Number(target.getAttribute("customValue")));
            onChange?.(Number(target.getAttribute("customValue")));
          }
        }}
      />,
    );
  }

  return stars;
};
